<button
  type="button"
  class="icon-button"
  aria-label="Menu"
  [attr.aria-expanded]="open()"
  aria-haspopup="menu"
  (click)="toggle($event)">
  <i class="pi pi-bars"></i>
</button>

@if (open()) {
  <div class="dropdown nav-menu" role="menu">
    <button type="button" class="menu-item" role="menuitem" (click)="goTo('/')">
      <i class="pi pi-home menu-item-icon"></i>
      <span>Home</span>
    </button>
    <button type="button" class="menu-item" role="menuitem" (click)="goTo('/form-builder')">
      <i class="pi pi-file menu-item-icon"></i>
      <span>Manage Forms</span>
    </button>
    <button type="button" class="menu-item" role="menuitem" (click)="goTo('/workflows')">
      <span class="material-symbols-outlined menu-item-icon">account_tree</span>
      <span>Workflow Designer</span>
    </button>
    <button
      type="button"
      class="menu-item"
      role="menuitem"
      aria-haspopup="true"
      [attr.aria-expanded]="onboardingOpen()"
      (click)="toggleOnboarding()">
      <span class="material-symbols-outlined menu-item-icon">app_registration</span>
      <span>Onboarding</span>
      <i class="pi pi-chevron-right submenu-arrow" [class.open]="onboardingOpen()"></i>
    </button>
    @if (onboardingOpen()) {
      <div class="submenu" role="group" aria-label="Onboarding">
        <button type="button" class="menu-item" role="menuitem" (click)="goTo('/user-management')">
          <span class="material-symbols-outlined menu-item-icon">manage_accounts</span>
          <span>Users</span>
        </button>
        <button type="button" class="menu-item" role="menuitem" (click)="goTo('/funder-management')">
          <span class="material-symbols-outlined menu-item-icon">account_balance</span>
          <span>Funders</span>
        </button>
        <button type="button" class="menu-item" role="menuitem" (click)="goTo('/programme-family-management')">
          <span class="material-symbols-outlined menu-item-icon">account_tree</span>
          <span>Programme Families</span>
        </button>
        <button type="button" class="menu-item" role="menuitem" (click)="goTo('/programme-type-management')">
          <span class="material-symbols-outlined menu-item-icon">category</span>
          <span>Programme Types</span>
        </button>
        <button type="button" class="menu-item" role="menuitem" (click)="goTo('/delivery-partner-management')">
          <span class="material-symbols-outlined menu-item-icon">handshake</span>
          <span>Delivery Partners</span>
        </button>
        <button type="button" class="menu-item" role="menuitem" (click)="goTo('/client-management')">
          <span class="material-symbols-outlined menu-item-icon">business</span>
          <span>Client</span>
        </button>
      </div>
    }
    <button type="button" class="menu-item" role="menuitem" (click)="goTo('/settings')">
      <i class="pi pi-cog menu-item-icon"></i>
      <span>Settings</span>
    </button>
  </div>
}
